var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "product-teaser" }, [
    _c(
      "a",
      {
        staticClass: "product-teaser__link",
        class: { "product-teaser__link--grid": _vm.type == "grid" },
        attrs: { href: _vm.product.link }
      },
      [
        _c(
          "div",
          { staticClass: "product-teaser__container" },
          [
            _vm.product.show_price
              ? _c("sale-flash", {
                  attrs: {
                    product: _vm.product,
                    "teaser-mode": true,
                    "sale-type": "teaser"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "product-teaser__image-container" },
              [
                _vm.product.image
                  ? _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: _vm.product.image.productTeaser,
                          expression: "product.image.productTeaser"
                        }
                      ],
                      staticClass: "product-teaser__image",
                      attrs: {
                        srcset:
                          _vm.product.image.productTeaser +
                          " 1x, " +
                          _vm.product.image.productTeaserX2 +
                          " 2x",
                        alt: ""
                      }
                    })
                  : _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: _vm.$modeoL10n.placeholder_img,
                          expression: "$modeoL10n.placeholder_img"
                        }
                      ],
                      staticClass: "product-teaser__image",
                      attrs: { alt: "" }
                    }),
                _vm._v(" "),
                _vm.product.brand.modeo_plus && !_vm.product.sale
                  ? _c(
                      "span",
                      {
                        staticClass: "modeo-plus",
                        attrs: { "aria-label": "Modeo+" }
                      },
                      [_vm._v("+")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("product-sticker", { attrs: { id: _vm.product.sticker } })
              ],
              1
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "product-teaser__heading" }, [
              _vm.product.brand.modeo_plus
                ? _c("span", { staticClass: "modeo-plus" }, [
                    _vm._v(_vm._s(_vm.product.brand.modeo_plus.name))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product.brand && _vm.product.brand.name
                ? _c("span", {
                    staticClass: "product-teaser__brand",
                    domProps: {
                      innerHTML: _vm._s(_vm.$sanitize(_vm.product.brand.name))
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._v("\n        " + _vm._s(_vm.product.name) + "\n      ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "product-teaser__price price" }, [
              _vm.hasPrice
                ? _c(
                    "div",
                    {
                      staticClass:
                        "product-teaser__price-amount-container price-amount-container price-amount-container--small"
                    },
                    [
                      _vm.product.variations_has_different_prices
                        ? _c("span", { staticClass: "starting-from" }, [
                            _vm._v("alk.")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "product-teaser__price-amount price-amount",
                          class: {
                            "price-amount--ins":
                              _vm.product.price_from_with_add_ons !=
                              _vm.product.regular_price_from_with_add_ons
                          }
                        },
                        [
                          _c("price", {
                            attrs: {
                              "price-without-tax":
                                _vm.product.prices_without_tax
                                  .price_from_with_add_ons,
                              "price-with-tax":
                                _vm.product.prices_with_tax
                                  .price_from_with_add_ons
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.product.price_from_with_add_ons !=
                      _vm.product.regular_price_from_with_add_ons
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "product-teaser__price-amount price-amount price-amount--del"
                            },
                            [
                              _c("price", {
                                attrs: {
                                  "price-without-tax":
                                    _vm.product.prices_without_tax
                                      .regular_price_from_with_add_ons,
                                  "price-with-tax":
                                    _vm.product.prices_with_tax
                                      .regular_price_from_with_add_ons
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "price-details price-details--small",
                  class: { "price-details--no-price": !_vm.hasPrice }
                },
                [
                  _vm.hasPrice
                    ? _c(
                        "span",
                        {
                          staticClass: "product-teaser__tax tax",
                          class: {
                            "tax--highlight":
                              _vm.product.outlet &&
                              !_vm.$store.getters.showPricesWithVat
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$modeoL10n.vat) +
                              " " +
                              _vm._s(_vm.$store.getters.displayVat)
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "btn btn--buy btn--buy-small",
                      class: { "btn--buy-no-price": !_vm.hasPrice }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.product.disable_buying || !_vm.hasPrice
                            ? _vm.$modeoL10n.check_out
                            : _vm.$modeoL10n.buy
                        )
                      )
                    ]
                  )
                ]
              )
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3befcc86", { render: render, staticRenderFns: staticRenderFns })
  }
}